module.exports = __webpack_public_path__ + "static/media/25_000_Racoons.16dca0f1.webp";